import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SubdivisionService {
  region=[
  "Ariana","Beja","Ben Arous","Bizerte","Jendouba","Gabes","Gafsa","Kairouan","Kasserine",
  "	Kebili","Kef","Mahdia","Manouba","Medenine","Monastir","Nabeul","Sfax","Sidi bouzid",
  "Siliana","Sousse","Tataouine","Tozeur","Tunis","Zaghouan" ];

   ville_tunisie ={
    "Ariana":["أريانة المدينة"," حي التضامن"," قلعة الأندلس"," المنيهلة","رواد"," سيدي ثابت","سكرة"],
    
    "Beja":["عمدون",
     " باجة الشمالية",
      "باجة الجنوبية",
     " قبلاط",
      "مجاز الباب",
      "نفزة",
      "تبرسق",
      "تستور",
      "تيبار"],
      "Ben Arous":[
        "بن عروس المدينة",
    "بومهل البساتين",
    "المروج",
    "الزهراء",
    "فوشانة",
    "حمام الشط",
    "حمام الأنف",
    "المحمدية",
    "المدينة الجديدة",
    "مقرين",
    "مرناق",
    "رادس",
    
      ],
      "Bizerte":[
        "بنزرت المدينة",
    "جومين",
    "العالية",
    "غزالة",
    "ماطر",
    "منزل بورقيبة",
    "منزل جميل",
    "رأس الجبل",
    "سجنان",
    "تينجة",
    "أوتيك",
    "جرزونة",
    
      ],
      "Gabes":[
        "قابس المدينة",
        "قابس الغربية",
        "قابس الجنوبية",
        "غنوش",
        "الحامة",
        "مارث",
        "مطماطة",
        "مطماطة الجديدة",
        "منزل الحبيب",
        "المطوية"
      ],
      "Gafsa":[

        "بلخير",
        "قفصة الشمالية",
        "قفصة الجنوبية",
        "القطار",
        "القصر",
        "المظيلة",
        "المتلوي",
        "أم العرائس",
        "الرديف",
        "السند",
        "سيدي عيش"
      ],
      "Jendouba":[

        "جندوبة المدينة",
        "عين دراهم",
        "بلطة بوعوان",
        "بوسالم",
        "فرنانة",
        "غار الدماء",
        "جندوبة الشمالية",
        "وادي مليز",

      ],
      "Kairouan":[

        "العلا",
        "بوحجلة",
        "الشبيكة",
        "الشراردة",
        "حفوز",
        "حاجب العيون",
        "القيروان الشمالية",
        "القيروان الجنوبية",
        "نصر الله",
        "الوسلاتية",
        "السبيخة",
      ],
      "Kasserine":[
        "العيون",
          "الزهور",
          "فريانة",
          "فوسانة",
          "حاسي الفريد",
          "حيدرة",
          "جدليان",
          "القصرين الشمالية",
          "القصرين الجنوبية",
          "ماجل بلعباس",
          "سبيطلة",
          "سبيبة",
          "تالة",
      ],
      "Kebili":[
        "دوز الشمالية",
        "دوز الجنوبية",
        "الفوار",
        "قبلي الشمالية"
        ,"قبلي الجنوبية",
        "سوق الأحد",
      ],
      "Kef":[
                "الدهماني",
        "السرس",
        "الجريصة",
        "القلعة الخصبة",
        "قلعة سنان",
        "الكاف الشرقية",
        "الكاف الغربية",
        "القصور",
        "نبر",
        "ساقية سيدي يوسف",
        "تاجروين",

      ],
      "Mahdia":[

        "المهدية" ,
        "المهدية المدينة",
        "بومرداس",
        "الشابة",
        "شربان",
        "الجم",
        "هبيرة",
        "قصور الساف",
        "ملولش",
        "أولاد الشامخ",
        "سيدي علوان",
        "السواسي",
      ],
      "Manouba":[
        "منوبة المدينة",
        "برج العامري",
        "دوار هيشر",
        "البطان",
        "الجديدة",
        "المرناقية",
        "وادي الليل",
        "طبربة",
      ],
      "Medenine":[

        "بنقردان",
        "بني خداش",
        "جربة عجيم",
        "جربة ميدون",
        "جربة حومة السوق",
        "مدنين الشمالية",
        "مدنين الجنوبية",
        "سيدي مخلوف",
        "جرجيس",
      ],
      "Monastir":[

        "المنستير المدينة",
        "البقالطة",
        "بنبلة",
        "بني حسان",
        "جمال",
        "قصر هلال",
        "قصيبة المديوني",
        "المكنين",
        "الوردانين",
        "الساحلين",
        "صيادة + لمطة + بوحجر",
        "طبلبة",
        "زرمدين",
      ],
      "Nabeul":[
        "نابل المدينة",
        "بني خلاد",
        "بني خيار",
        "بوعرقوب",
        "دار شعبان الفهري",
        "الميدة",
        "قرمبالية",
        "حمام الأغزاز",
        "الحمامات",
        "الهوارية",
        "قليبية",
        "قربة",
        "منزل بوزلفة",
        "منزل تميم",
        "سليمان",
        "تاكلسة",

      ],
      "Sfax":[
              " صفاقس المدينة",
        "عقارب",
        "بئر علي بن خليفة",
        "العامرة",
        "الغريبة",
        "الحنشة",
        "جبنيانة",
        "قرقنة",
        "المحرس",
        "منزل شاكر",
        "ساقية الدائر",
        "ساقية الزيت",
        "صفاقس الغربية",
        "صفاقس الجنوبية",
        "الصخيرة",
        "طينة",
      ],
      "Sidi bouzid":[
                  "بئر الحفي",
          "جلمة",
          "المزونة",
          "المكناسي",
          "منزل بوزيان",
          "أولاد حفوز",
          "الرقاب",
          "السبالة",
          "سيدي علي بن عون",
          "سيدي بوزيد الشرقية",
          "سيدي بوزيد الغربية",
          "السوق الجديد",
      ],
      "Siliana":[
        "برقو",
        "بوعرادة",
        "العروسة",
        "الكريب",
        "قعفور",
        "كسرى",
        "مكثر",
        "الروحية",
        "سيدي بورويس",
        "سليانة الشمالية",
        "سليانة الجنوبية",
      ],
      "Sousse":[

       " سوسة المدينة",
"أكودة",
"بوفيشة",
"النفيضة",
"حمام سوسة",
"هرقلة",
"القلعة الكبرى",
"القلعة الصغرى",
"كندار",
"مساكن",
"سيدي بوعلي",
"سيدي الهاني",
"معتمدية سوسة جوهرة",
"سوسة الرياض",
"سوسة سيدي عبد الحميد",
"الزاوية قصيبة الثريات",
      ],
      "Tataouine":[

                    "بئر الأحمر",
            "الذهيبة",
            "غمراسن",
            "رمادة",
            "الصمار",
            "تطاوين الشمالية",
            "تطاوين الجنوبية",

      ],
      "Tozeur":[

                  "توزر المدينة",
          "دقاش",
          "حزوة",
          "نفطة",
          "تمغزة",  
      ],
      "Zaghouan":[
        "زغوان المدينة",
        "بئر مشارقة",
        "الفحص",
        "الناظور",
        "صواف",
        "الزريبة"
      ],
      "Tunis":[
        "تونس المدينة,",
"باب البحر",
"باب السويقة",
"باردو",
"ضفاف البحيرة",
"قرطاج",
"حي الخضراء",
"المنزه",
"الوردية",
"حي التحرير",
"الزهور",
"الحرايرية",
"جبل الجلود",
"الكبارية",
"حلق الوادي",
"المرسى (تونس)",
"الكرم (تونس)",
"العمران",
"العمران الأعلى",
"سيدي البشير",
"سيدي حسين",
"السيجومي",
      ]
    
    
    }
    
  constructor() { }


}
